import { configFileLoad, type ConfigCustomer, type ConfigObject, type ConfigServer } from "@src/helpers/other/configJson";

export type { ConfigCustomer, ConfigServer };

/**
 * Конфигурация приложения из `public/config.json`.
 */
export type AppConfig = ConfigObject;

/**
 * OMP-сервер из config.json (алиас {@link ConfigServer}).
 */
export type ServerHost = ConfigServer;

/**
 * Загружает `public/config.json`.
 * @returns Разобранный конфиг приложения
 */
export async function loadAppConfig(): Promise<AppConfig> {
    return configFileLoad();
}
